import { CheckBox } from "@whatslly/ui-components/v2/BaseElements/CheckBox";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { UserDefaultChannels } from "@whatslly/types/User";
import { OrgConfigs } from "@whatslly/types/OrgConfigs";

export type DefaultUserChannelsName = keyof UserDefaultChannels;

export const DefaultUserChannels = ({
  orgConfigs,
  selectedChannels,
  updateDefaultChannels,
}: {
  orgConfigs: OrgConfigs | undefined;
  selectedChannels: UserDefaultChannels | undefined;
  updateDefaultChannels: (channel: DefaultUserChannelsName, enabled: boolean) => void;
}) => {
  const { t } = useTranslation();

  const channels = useMemo(
    () => ({
      telegram: orgConfigs?.allow_telegram,
      imessage: orgConfigs?.allow_imessage,
      "whatsapp-web": true,
    }),
    [orgConfigs?.allow_imessage, orgConfigs?.allow_telegram]
  );

  return (
    <div>
      {Object.entries(channels).map(([channel, enabled]) =>
        enabled ? (
          <CheckBox
            key={channel}
            textFontSize="small"
            marginBottom="extra-small"
            text={t(`default_channels.${channel}`)}
            checked={selectedChannels?.[channel as DefaultUserChannelsName] ?? false}
            onChange={(e) => updateDefaultChannels(channel as DefaultUserChannelsName, e.target.checked)}
            data-testid={`default-channel-${channel}`}
          />
        ) : null
      )}
    </div>
  );
};
